import MenuItem from '@mui/material/MenuItem'
import Select, { SelectChangeEvent } from '@mui/material/Select'
import React from 'react'
import LazyLoad from 'react-lazyload'
import styled from 'styled-components'

type IProps = {
  language: string
  handleChange: (event: SelectChangeEvent<string>) => void
}

const SwitchLang = (props: IProps) => {
  return (
    <>
      <LazyLoad>
        <Select variant="standard" defaultValue={props.language} value={props.language} onChange={props.handleChange}>
          <MenuItemWrapper dense value={'EN'}>
            <img className="language-icon" src={'/images/home/usa-icon.png'} alt="en" />
            <a>{'English'}</a>
          </MenuItemWrapper>
          <MenuItemWrapper dense value={'ID'}>
            <img className="language-icon" src={'/images/home/id-icon.png'} alt="id" />
            <a>{'ID'}</a>
          </MenuItemWrapper>
        </Select>
      </LazyLoad>
    </>
  )
}

export default SwitchLang

const MenuItemWrapper = styled(MenuItem)`
  &.MuiMenuItem-root.Mui-selected {
    background-color: #ccc;
  }
  &.MuiMenuItem-root.Mui-selected:hover {
    background-color: #ccc;
  }
`
